export const MEMO_STATUS = {
  DECLINE: 'Decline',
  CONFIRM: 'Confirm',
  SENT: 'Sent'
};
